import React from "react";
import { Box, Container, Typography, Grid, Link } from "@mui/material";

const Footer: React.FC = () => {
  return (
    <Box
      sx={{
        backgroundColor: "#1e1e1e",
        color: "white",
        //mt: 10,
        pt: 6,
        pb: 3,
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          <Grid size={{ xs: 12, md: 4 }}>
            <Typography variant="h6" gutterBottom>
              IndSol
            </Typography>

            <Typography variant="body2">
              <Typography variant="body2">
                eMachine is a smart manufacturing platform that connects
                machines, captures production data, and delivers real-time
                insights to improve efficiency, reduce downtime, and optimize
                shop-floor performance.
              </Typography>
            </Typography>
          </Grid>

          <Grid size={{ xs: 12, md: 4 }}>
            <Typography variant="h6" gutterBottom>
              Quick Links
            </Typography>

            <Link href="/" color="inherit" display="block">
              Home
            </Link>

            <Link href="/pricing" color="inherit" display="block">
              Pricing
            </Link>

            <Link href="/contact" color="inherit" display="block">
              Contact
            </Link>
          </Grid>

          <Grid size={{ xs: 12, md: 4 }}>
            <Typography variant="h6" gutterBottom>
              Contact
            </Typography>

            <Typography variant="body2">
              10th floor Tower-B Unitech Cyber Park, Sector 39, Gurugram,
              Haryana, 122003
            </Typography>

            <Typography variant="body2">Info@emachine.in</Typography>
          </Grid>
        </Grid>

        <Box textAlign="center" mt={5}>
          <Typography variant="body2">
            © {new Date().getFullYear()} IndSol Automation. All rights reserved.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
